module.exports = __webpack_public_path__ + "static/media/about.ffa401c0.png";